import Vue from 'vue'
import configs from '@/config'
import { mockDataResponse, mockDataResponseV2 } from '../components-v2/onboarding/sampleFeatureBasedOptionsResponse'

let resource = null

const actions = {
  getFeatures: {
    method: 'GET',
    url: `${configs.baseUrl}/api/onboarding-feature-based-options`,
  },
  createOnboardingPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/create-featured-based-onboarding-presentation`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFeatures = async (params) => {
  // const res = await resource.getFeatures(params)

  return mockDataResponse(params)
}

const getFeaturesV2 = async (params) => {
  return mockDataResponseV2(params)
}

const createOnboardingPresentation = async (params) => {
  const res = await resource.createOnboardingPresentation(params)

  return res && res.body
}

export default {
  initResource,
  getFeatures,
  getFeaturesV2,
  createOnboardingPresentation,
}
